import { GetPricesData, GetPricesResult } from 'hydra-data-types';
import { INITIAL_ENTRY_STATE } from '../entry/EntryState';
import { LoadingAndErrorState } from '../LoadingAndErrorState';

/** Coupons and pricing for all items (trials and subscriptions) offered.
 * Relevant functions include: `getPrices`.
 * Relevant query params include `plan` */
export type PricingState = Pick<GetPricesResult, 'currency' | 'coupon' | 'itemPrices'> &
  Pick<GetPricesData, 'couponCode'> &
  LoadingAndErrorState;

/** Entry sets the currency and the URL coupon before the first screen. */
export const INITIAL_PRICING_STATE: PricingState = {
  currency: INITIAL_ENTRY_STATE.currency,
  couponCode: undefined,
  coupon: undefined,
  itemPrices: [],
  loading: false,
  error: undefined,
};
